module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout",
    attrs: {
      "rightVisible": true
    }
  }, [_c('template', {
    slot: "left"
  }, [_c('ElementMenu', {
    attrs: {
      "root": _vm.settingsElement,
      "activeKey": _vm.activeMenuKey
    },
    on: {
      "click": _vm.elementMenuClicked
    }
  })], 1), _vm._v(" "), _c('AutomaticScroll', {
    attrs: {
      "scrolling-element-id": "middle-column",
      "active-section-key": _vm.activeMenuKey,
      "section-element-class": "section-title"
    },
    on: {
      "change": _vm.scrolled
    }
  }, [_c('ElementControl', {
    attrs: {
      "element": _vm.activeElement
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56593f40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LayoutPage2.vue
// module id = 2553
// module chunks = 1